module.exports = {"data":{"contributionsJson":{"name":"clean","www_url":"http://tabea.guhl.net/","thema":"kaffee","issue_month":"June","issue_year":2007,"issue_date":200706,"artist":"tabea","location":"Schweiz","email":"tabea@guhl.net","id":"contribution_289","media_type":"still_image","position_in_section":2,"media_uri":"media/2007/June/still_image/clean02.jpg","media_th_uri":"media/2007/June/still_image/tn_clean02.jpg","still_image_count":5,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_289"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200706-still-image-2.json
// module id = 938
// module chunks = 51000553958166